/*
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2026 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { addToEndOfChain, Handler } from "@insite/client-framework/HandlerCreator";
import { chain } from "@insite/client-framework/Store/Components/AddToListModal/Handlers/SetAddToListModalIsOpen";

interface Parameter {
    productInfos?: Omit<ProductInfo, "productDetailPath">[];
    modalIsOpen: boolean;
    // XNG-Change
    showProductsSelection?: boolean;
}

type HandlerType = Handler<Parameter>;


const XngUpdateModalVariant: HandlerType = props => {
    props.dispatch({ type: "xCommon/update", data: { key: "showProductsSelection", value: !!props.parameter.showProductsSelection } });
};


addToEndOfChain(chain, XngUpdateModalVariant);
